var ptwGiftNoteValue = '';

function ptwSetGiftNote() {
  jQuery.getJSON('/cart.js', function(cart) {
    if(cart.attributes['gift-note'])
    {
      jQuery("#ptw-text-message, #minicart-hidden-note").val(cart.attributes['gift-note']);  
    }
  });
}

function ptwAfterWrapinLoadHook() {
  var $ptwobject = window.jQuery;
  $ptwobject('#ptw-text-message').attr('name', 'attributes[gift-note]');
  setTimeout(function(){
    ptwSetGiftNote();
  }, 1000);

  jQuery('#ptw-text-message').bind('keypress keyup blur', function() {
    jQuery('#minicart-hidden-note').val(jQuery(this).val());
  });

  $ptwobject(".ptwCustomCheckout").click(function(){
    var ptw_gift_note = $ptwobject("#ptw-text-message").val();
    var formData = new FormData();
    formData.append("attributes[gift-note]", ptw_gift_note);
    formData.append("note", ptw_gift_note);
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => console.log(data));
    //window.location.reload();
    ajaxCart.refreshCart(); 
    console.log("Gift Wrap Added 1");
  });
  
  $ptwobject('.ptw-gift-image').prependTo('.ptw-app-label label');
  $ptwobject("#ptw-add-gift-pro").attr("id", "ptw-add-gift-pro-ck");
  $ptwobject("#ptw-add-gift-pro-ck").attr("type", "button");
  $ptwobject("#ptw-add-gift-pro-ck").removeClass("button");
  $ptwobject("#ptw-add-gift-pro-ck").click(function(){
        var ptwVariantId = $ptwobject("#ptw-variant-id").val();
        var ptw_gift_note = $ptwobject("#ptw-text-message").val();

        var ptwProductProps = {
            "gift-note": ptw_gift_note,
            "note": ptw_gift_note,
          };
        var ptwProductParams = {
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: [
              {
                quantity: 1,
                id: ptwVariantId,
              },
            ],
          },
          dataType: "json",
          cache: false,
          async: false
        };
                
        $ptwobject.ajax(ptwProductParams).done(function (data) {
          var formData = new FormData();
          formData.append("attributes[gift-wrapped]", "true");
          formData.append("attributes[gift-note]", ptw_gift_note);
          formData.append("note", ptw_gift_note);
          
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData
          })
          .then(response => response.json())
          .then(data => console.log(data));
          //window.location.reload();
          document.dispatchEvent(
            new CustomEvent('theme:cart:refresh')
          );
          console.log("Gift Wrap Added 1");
        })
  });
}